/** @jsxImportSource @emotion/react */
import moment from 'moment';
import React from 'react';
import CurrencyFormat from 'react-currency-format';
import useSWR from 'swr';
// eslint-disable-next-line no-unused-vars
import tw from 'twin.macro';
import { swrfetcher } from '../../../utils/swrFetcher';
import DataGridViewTemp from '../../Common/DataGridViewTemp';
import TransactionCard from '../../Common/TransactionCard';
import numberFormatter from '../../../utils/numberFormatter';

const Overview = () => {
  const [day, setDay] = React.useState('Today');
  const [date, setDate] = React.useState([moment().format('yyyy-MM-DD'), null]);

  React.useEffect(() => {
    if (day === 'Today') {
      setDate([moment().startOf('day').format('yyyy-MM-DD'), null]);
    } else if (day === 'Yesterday') {
      setDate([
        moment().subtract(1, 'days').startOf('day').format('yyyy-MM-DD'),
        null,
      ]);
    } else if (day === 'This Week') {
      setDate([moment().startOf('week').format('yyyy-MM-DD'), null]);
    } else if (day === 'This Month') {
      setDate([moment().startOf('month').format('yyyy-MM-DD'), null]);
    } else if (day === 'Last Month') {
      setDate([
        moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
      ]);
    } else {
      setDate([moment().startOf('year').format('YYYY-MM-DD'), null]);
    }
  }, [day]);

  /* SWR URLs */
  const PosUrl = `/apis/v1/bizzdesk/admin/transaction/POS/getMetrics?startDate=${
    date[0]
  }${!date[1] ? '' : `&endDate=${date[1]}`}`;
  const walletUrl = `/apis/v1/bizzdesk/admin/transaction/WalletWithdrawal/getMetrics?startDate=${
    date[0]
  }${!date[1] ? '' : `&endDate=${date[1]}`}`;
  const receivableUrl = `/apis/v1/bizzdesk/admin/transaction/Receivable/getMetrics?startDate=${
    date[0]
  }${!date[1] ? '' : `&endDate=${date[1]}`}`;
  const bizzDeskUrl = `/apis/v1/bizzdesk/admin/transaction/Income/getMetrics?startDate=${
    date[0]
  }${!date[1] ? '' : `&endDate=${date[1]}`}`;

  /* User_token getter */
  const token = JSON?.parse(
    localStorage.getItem('token') || sessionStorage.getItem('token')
  );

  /* SWR call functions */
  const { data: PosData } = useSWR(
    [PosUrl, token, 'GET'],
    ([url, USER_TOKEN, method]) => swrfetcher(url, USER_TOKEN, method)
  );

  const { data: Walletata } = useSWR(
    [walletUrl, token, 'GET'],
    ([url, USER_TOKEN, method]) => swrfetcher(url, USER_TOKEN, method)
  );

  const { data: receivableData } = useSWR(
    [receivableUrl, token, 'GET'],
    ([url, USER_TOKEN, method]) => swrfetcher(url, USER_TOKEN, method)
  );

  const { data: bizzDeskData } = useSWR(
    [bizzDeskUrl, token, 'GET'],
    ([url, USER_TOKEN, method]) => swrfetcher(url, USER_TOKEN, method)
  );

  /* Data Arrays */
  const transactiionData = [
    {
      amount: (
        <CurrencyFormat
          value={11}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total successful transactions',
      value: numberFormatter(11),
    },
    {
      amount: (
        <CurrencyFormat
          value={PosData?.totalFailedTransactionsAmount}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total failed transactions',
      value: numberFormatter(12),
    },
    {
      amount: (
        <CurrencyFormat
          value={12}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total Pending transactions',
      value: numberFormatter(90),
    },
  ];

  const walletWithdrawalData = [
    {
      amount: (
        <CurrencyFormat
          value={11}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total successful transactions',
      value: numberFormatter(11),
    },
    {
      amount: (
        <CurrencyFormat
          value={Walletata?.totalFailedTransactionsAmount}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total failed transactions',
      value: numberFormatter(12),
    },
    {
      amount: (
        <CurrencyFormat
          value={12}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total Pending transactions',
      value: numberFormatter(90),
    },
  ];

  const receivableDataArray = [
    {
      amount: (
        <CurrencyFormat
          value={11}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total successful transactions',
      value: numberFormatter(11),
    },
    {
      amount: (
        <CurrencyFormat
          value={receivableData?.totalFailedTransactionsAmount}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total failed transactions',
      value: numberFormatter(12),
    },
    {
      amount: (
        <CurrencyFormat
          value={12}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total Pending transactions',
      value: numberFormatter(90),
    },
  ];

  const bizzDeskDataArray = [
    {
      amount: (
        <CurrencyFormat
          value={11}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total successful transactions',
      value: numberFormatter(11),
    },
    {
      amount: (
        <CurrencyFormat
          value={bizzDeskData?.totalFailedTransactionsAmount}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total failed transactions',
      value: numberFormatter(12),
    },
    {
      amount: (
        <CurrencyFormat
          value={12}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total Pending transactions',
      value: numberFormatter(90),
    },
  ];

  return (
    <>
      <div>
        <div tw="flex justify-between items-center">
          <Title className="font-500">Bank Card</Title>
        </div>

        <div tw="grid grid-cols-2 gap-3 md:grid-cols-3 xl:( gap-5) mt-5">
          {transactiionData.map(({ amount, value, title }, index) => {
            return (
              <TransactionCard
                key={index}
                title={title}
                amount={amount}
                value={value}
                isValidating={PosData}
                hasFilter={index === 0 && day}
                setFilter={index === 0 && setDay}
              />
            );
          })}
        </div>
      </div>

      <div tw="mt-10">
        <Title className="font-500">USSD</Title>

        <div tw="grid grid-cols-2 gap-3 md:grid-cols-3 xl:( gap-5) mt-5">
          {walletWithdrawalData.map(({ amount, value, title }, index) => {
            return (
              <TransactionCard
                key={index}
                title={title}
                amount={amount}
                value={value}
                isValidating={Walletata}
              />
            );
          })}
        </div>
      </div>

      <div tw="mt-10">
        <Title className="font-500">Bank Transfer</Title>

        <div tw="grid grid-cols-2 gap-3 md:grid-cols-3 xl:( gap-5) mt-5">
          {receivableDataArray.map(({ amount, value, title }, index) => {
            return (
              <TransactionCard
                key={index}
                title={title}
                amount={amount}
                value={value}
                isValidating={receivableData}
              />
            );
          })}
        </div>
      </div>

      <div tw="my-10">
        <Title className="font-500">Barter</Title>

        <div tw="grid grid-cols-2 gap-3 md:grid-cols-3 xl:( gap-5) mt-5">
          {bizzDeskDataArray.map(({ amount, value, title }, index) => {
            return (
              <TransactionCard
                key={index}
                title={title}
                amount={amount}
                value={value}
                isValidating={bizzDeskData}
              />
            );
          })}
        </div>
      </div>

      <div tw="my-10">
        <Title className="font-500">Paga</Title>

        <div tw="grid grid-cols-2 gap-3 md:grid-cols-3 xl:( gap-5) mt-5">
          {bizzDeskDataArray.map(({ amount, value, title }, index) => {
            return (
              <TransactionCard
                key={index}
                title={title}
                amount={amount}
                value={value}
                isValidating={bizzDeskData}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

const Title = tw.h3`tracking-[-0.02em] text-black`;

export default Overview;
